import {updateUnitAccessory} from '@/modules/ProjectModule/modules/UnitModule/api/unit.api';

export const getters = {
    accessoryIds: (state) => state.accessoryIds,
}

export const actions = {
    async updateAccessory({ commit, getters }, data) {
        const id = getters.unitId;
        return updateUnitAccessory({ ...data, id })
        .then((data) => commit('UPDATE_ACCESSORY', data));
    },
}

export const mutations = {
    UPDATE_ACCESSORY: (state, data) => {
        const { accessoryId, connected } = data;
        const index = state.accessoryIds.indexOf(accessoryId);

        if (connected && index === -1) {
            state.accessoryIds.push(accessoryId);
        }
        if (false === connected && index !== -1) {
            state.accessoryIds.splice(index, 1);
        }
    },
}
